<template>
    <div class="hover-message-wrapper" ref="hovermsg" :class="backgroundColour">
        <div class="hover-message">
            {{message}}
        </div>
    </div>
</template>

<script>
export default {
    name: 'hover-message',
    mounted() {
        window.onmousemove = this.handleMouseMove;
    },
    beforeDestroy() {
        window.onmousemove = null;
    },
    methods: {
        handleMouseMove(e) {
            // capture mouse position
            this.elementWidth = this.$refs.hovermsg.clientWidth;
            this.elementHeight = this.$refs.hovermsg.clientHeight;
            this.mouseX = e.clientX;
            this.mouseY = e.clientY;

            switch(this.position) {
                case 'right':
                    this.$refs.hovermsg.style.top = (this.mouseY - (this.elementHeight/2)) + 'px';
                    this.$refs.hovermsg.style.left = (this.mouseX + this.elementWidth + 40) + 'px';
                    break;
                case 'left':
                    this.$refs.hovermsg.style.top =  (this.mouseY - (this.elementHeight/2)) + 'px';
                    this.$refs.hovermsg.style.left = (this.mouseX - this.elementWidth - 40) + 'px';
                    break;
            }

            this.$refs.hovermsg.style.opacity = "1";

        }
    },
    data() {
        return {
            elementWidth: 10,
            elementHeight: 10,
            mouseX: 0,
            mouseY: 0,
        }
    },
    props: {
        message: String,
        colourScheme: String,
        position: String,
    },
    computed: {
        backgroundColour() {
            switch(this.colourScheme) {
                case 'warning':
                    return {
                        'warning': true
                    }
                case 'success':
                    return {
                        'success': true
                    }
            }
        },
    }
}
</script>

<style lang="scss">
    .hover-message-wrapper {
        opacity: 0;
        background-color: white;
        padding: 15px;
        position: fixed;
        z-index: 20000;
        top: 0px;
        left: 0px;
        border-radius: 6px;
        border-style: solid;
        border-width: 2px;
        color: #333;
        -webkit-box-shadow: 2px 2px 4px 1px rgba(0,0,0,0.49);
        box-shadow: 2px 2px 4px 1px rgba(0,0,0,0.49);

        -webkit-animation: fadein 500ms; /* Safari, Chrome and Opera > 12.1 */
        -moz-animation: fadein 500ms; /* Firefox < 16 */
        -ms-animation: fadein 500ms; /* Internet Explorer */
        -o-animation: fadein 500ms; /* Opera < 12.1 */
        animation: fadein 500ms;

    }
    .hover-message {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .warning {
        border-color: red;
        color: red;
    }

    .success {
        border-color: green;
        color: green;
    }

    @keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
    }

    /* Firefox < 16 */
    @-moz-keyframes fadein {
        from { opacity: 0; }
        to   { opacity: 1; }
    }

    /* Safari, Chrome and Opera > 12.1 */
    @-webkit-keyframes fadein {
        from { opacity: 0; }
        to   { opacity: 1; }
    }

    /* Internet Explorer */
    @-ms-keyframes fadein {
        from { opacity: 0; }
        to   { opacity: 1; }
    }
</style>